<template>
  <div>
    <sub-page-tabs
      :selected-index.sync="selectedTabIndex"
      :tabs="tabs"
      use-hash-state
      height="48"
    >
      <template #append-right>
        <screen-tab-filtering-button
          :filtering-input.sync="filteringInput"
          :review="review"
        />
      </template>
      <template #prepend-content>
        <screen-tab-filtering-status-bar
          v-if="filteringInput.hasFiltersApplied()"
          :review="review"
          :filtering-input="filteringInput"
          @clear="resetFilteringInput"
        />
      </template>
      <page-tab-panel>
        <screen-tab-pending
          :key="'pending-tab'"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 0"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <screen-tab-awaiting-you
          :key="'awaiting-you-tab'"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 1"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <screen-tab-your-votes
          :key="'your-votes-tab'"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 2"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <screen-tab-conflicting
          :key="'conflicting-tab'"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 3"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <screen-tab-complete
          :key="'relevant-tab'"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 4"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <screen-tab-complete
          :key="'not-relevant-tab'"
          :review="review"
          :current-researcher="currentResearcher"
          :filter-outcomes-to="['NOT_RELEVANT']"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 5"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
    </sub-page-tabs>
    <screen-tab-status-footer
      v-if="review"
      :review="review"
      :current-researcher="currentResearcher"
    />
    <screen-tab-status-footer-skeleton-loader v-else />
  </div>
</template>

<script>
import SubPageTabs from '@/components/Common/SubPageTabs';
import PageTabPanel from '@/components/Common/PageTabPanel';
import ScreenTabPending from './ScreenTabPending';
import ScreenTabAwaitingYou from './ScreenTabAwaitingYou';
import ScreenTabConflicting from './ScreenTabConflicting';
import ScreenTabComplete from './ScreenTabComplete';
import ScreenTabStatusFooter from './ScreenTabStatusFooter';
import ScreenTabStatusFooterSkeletonLoader from './ScreenTabStatusFooterSkeletonLoader';
import ScreenTabFilteringButton from './Filtering/ScreenTabFilteringButton';
import ScreenTabFilteringStatusBar from './Filtering/ScreenTabFilteringStatusBar';
import ScreenTabYourVotes from './ScreenTabYourVotes';
import {
  Review,
  Researcher,
  ReferenceFilteringInputDto,
} from '@/models';

export default {
  name: 'ScreenTab',
  components: {
    SubPageTabs,
    PageTabPanel,
    ScreenTabPending,
    ScreenTabAwaitingYou,
    ScreenTabConflicting,
    ScreenTabComplete,
    ScreenTabStatusFooter,
    ScreenTabStatusFooterSkeletonLoader,
    ScreenTabFilteringButton,
    ScreenTabFilteringStatusBar,
    ScreenTabYourVotes,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
  },
  data: () => ({
    selectedTabIndex: 0,
    filteringInput: new ReferenceFilteringInputDto(),
  }),
  computed: {
    tabs() {
      return [
        {
          label: 'Pending',
          count: this.review.screeningProgressSummary.unscreenedCount,
          hash: '#pending',
        },
        {
          label: 'Awaiting You',
          count: this.review.screeningProgressSummary
            .userRequiredVoteCount,
          hash: '#awaiting-you',
        },
        {
          label: 'Your Votes',
          count: this.review.screeningProgressSummary.userVoteCount,
          hash: '#your-votes',
        },
        {
          label: 'Conflicted',
          count: this.review.screeningProgressSummary
            .conflictedScreenCount,
          hash: '#conflicted',
        },
        {
          label: 'Relevant',
          count:
            this.review.screeningOutcomeSummary.relevantCount +
            this.review.screeningOutcomeSummary.notSureCount,
          hash: '#relevant',
        },
        {
          label: 'Not Relevant',
          count: this.review.screeningOutcomeSummary.notRelevantCount,
          hash: '#not-relevant',
        },
      ];
    },
  },
  methods: {
    resetFilteringInput() {
      this.filteringInput = new ReferenceFilteringInputDto();
    },
  },
};
</script>
